(() => {
    const source = document.querySelector('[data-special-order-variants]');
    if (!source) return;

    let specialOrderVariants = {};
    try {
        specialOrderVariants = JSON.parse(source.textContent);
    } catch (error) {
        return;
    }

    const sync = (variantId) => {
        const isSpecialOrder = specialOrderVariants[String(variantId)] === true;
        for (const content of document.querySelectorAll('[data-special-order-content]')) {
            content.hidden = !isSpecialOrder;
        }
    };

    const initialVariantId = document.querySelector('form input[name="id"]')?.value;
    sync(initialVariantId);

    document.addEventListener('special-order:variant-change', (event) => {
        sync(event.detail.variantId);
    });

    window.specialOrderPdp = { sync };
})();
